module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjExIiB2aWV3Qm94PSIwIDAgNiAxMSI+CiAgICA8cGF0aCBmaWxsPSIjMzQ4MkZEIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik01Ljc4NyA0Ljk3N0EuNzY4Ljc2OCAwIDAgMSA2IDUuNTAzYzAgLjE4OC0uMDcuMzgyLS4yMTMuNTI2bC00LjU2IDQuNzVhLjY5NS42OTUgMCAwIDEtMS4wMTYgMCAuNzY3Ljc2NyAwIDAgMSAwLTEuMDU3TDMuNTUgNi4yNWExLjA5OCAxLjA5OCAwIDAgMCAwLTEuNDk1TC4yMSAxLjI3OGEuNzY3Ljc2NyAwIDAgMSAwLTEuMDU4LjY5NS42OTUgMCAwIDEgMS4wMTYgMGw0LjU2IDQuNzU3eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./static/images/arrow.svg
// module id = fD0r
// module chunks = 1